import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import PhotoInput from "../components/PhotoInput";
import StatusChip from "../components/StatusChip";

const inputCls = "mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0E2240]";
const dt = (s) => new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeZone: "Asia/Kolkata" });

export default function Damage() {
  const { user } = useAuth();
  const [reports, setReports] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [show, setShow] = useState(false);
  const [f, setF] = useState({ vehicle_id: "", severity: "Minor", description: "", photos: [] });

  const load = () => { api.get("/damage").then((r) => setReports(r.data)); api.get("/vehicles").then((r) => setVehicles(r.data)); };
  useEffect(load, []);

  const submit = async () => {
    if (!f.vehicle_id || !f.description) { toast.error("Vehicle and description required"); return; }
    try {
      await api.post("/damage", f);
      toast.success("Damage reported — SM notified"); setShow(false); load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const updateStatus = async (id, status) => {
    try { await api.patch(`/damage/${id}`, { status }); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="px-4 py-5 lg:px-8 max-w-3xl">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl font-bold text-[#0E2240]">Damage Reports</h1>
        <button data-testid="damage-add-btn" onClick={() => setShow(!show)} className="rounded-full bg-[#BB162B] px-4 py-2 text-sm font-bold text-white">+ Report</button>
      </div>

      {show && (
        <div className="mt-4 space-y-3 rounded-2xl border border-slate-200 bg-white p-4">
          <select data-testid="damage-vehicle-select" value={f.vehicle_id} onChange={(e) => setF({ ...f, vehicle_id: e.target.value })} className={inputCls}>
            <option value="">Select vehicle…</option>
            {vehicles.map((v) => <option key={v.id} value={v.id}>{v.reg_no} — {v.model}</option>)}
          </select>
          <div className="flex gap-2">
            {["Minor", "Major", "Accident"].map((s) => (
              <button key={s} data-testid={`severity-${s.toLowerCase()}`} onClick={() => setF({ ...f, severity: s })}
                className={`flex-1 rounded-xl border py-2.5 text-sm font-bold ${f.severity === s ? "border-[#BB162B] bg-[#BB162B] text-white" : "border-slate-200 text-slate-600"}`}>{s}</button>
            ))}
          </div>
          <textarea data-testid="damage-description-input" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} rows={2} placeholder="Describe the damage…" className={inputCls} />
          <PhotoInput label="damage photo" value={f.photos[0]} onChange={(b) => setF({ ...f, photos: [b] })} testId="damage-photo-btn" />
          <button data-testid="damage-submit-btn" onClick={submit} className="w-full rounded-xl bg-[#0E2240] py-3 text-sm font-bold text-white">Submit Report</button>
        </div>
      )}

      <div className="mt-4 space-y-3">
        {reports.map((r) => (
          <div key={r.id} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-heading font-bold text-[#0E2240]">{r.reg_no} · {r.severity}</div>
                <div className="text-xs text-slate-500 mt-0.5">{r.description}</div>
                <div className="text-[11px] text-slate-400 mt-0.5">{dt(r.created_at)}{r.kec_name && ` · trip by ${r.kec_name}`}</div>
              </div>
              <StatusChip status={r.status} />
            </div>
            {["sm", "admin"].includes(user.role) && r.status === "reported" && (
              <div className="mt-3 flex gap-2">
                <button data-testid={`damage-approve-repair-${r.id}`} onClick={() => updateStatus(r.id, "repair_approved")} className="flex-1 rounded-xl bg-[#0E2240] py-2 text-xs font-bold text-white">Approve Repair</button>
                <button onClick={() => updateStatus(r.id, "closed")} className="flex-1 rounded-xl border border-slate-300 py-2 text-xs font-bold text-slate-600">Close</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
